module.exports = __webpack_public_path__ + "static/media/seal-kid-safe.686b45d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seal-kid-safe.png
// module id = 261
// module chunks = 4